import axios from '../axiosConfig'; // Adjust the import path accordingly
import User from "./User";

//const express_server_url = process.env.REACT_APP_SERVER_URL;
const express_server_url = window.SERVER_CONFIG.REACT_APP_SERVER_URL;
const dotnet_server_url = window.SERVER_CONFIG.REACT_APP_DOTNETSERVER_URL;

var WebApiUrl = express_server_url;
WebApiUrl = express_server_url.replace("localhost", window.location.hostname);

const ModuleName = {

    insertModuleName: async (data) => {
        try {
            const apiUrl = `${WebApiUrl}/api/ModuleName`;
            const response = await axios.post(apiUrl, {
                moduleName: data.moduleName,
                moduleDescription: data.moduleDescription,
            }, {
                withCredentials: true,
                credentials: 'include',
            });
            console.log("Response:", response.data);
            return response.data;
        } catch (error) {
            console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },
    // ************************* Get All ***************************
    getModuleNames: async () => {
        try {
            const apiUrl = `${WebApiUrl}/api/ModuleName/GetModuleNames`;
            const response = await axios.post(apiUrl, {
                filter: [],
                order: [
                    {
                        propertyName: "string",
                        ascending: false
                    }
                ],
                pageNumber: 0,
                pageSize: 50000
            }, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;

        } catch (error) {
            console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
        }
    },

    // ************************* Delete ****************************
    deleteModuleName: async (moduleId) => {
        try {
            const apiUrl = `${WebApiUrl}/api/ModuleName?moduleId=${moduleId}`;
            const response = await axios.delete(apiUrl, {
                withCredentials: true,
            });
            console.log('Delete Response:', response.data.result);
            return true;
        } catch (error) {
            console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
        }
    },

    // ************************* Get By Id ****************************
    getModuleNameById: async (moduleId) => {
        try {
            const apiUrl = `${WebApiUrl}/api/ModuleName?moduleId=${moduleId}`;
            const response = await axios.get(apiUrl, {}, {
                withCredentials: true,
            });
            console.log('Response:', response.data.result);
            return response.data.result;
        } catch (error) {
            console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }
        }
    },
    // *************************** Update ***************************
    updateModuleName: async (data) => {
        try {
            const apiUrl = `${WebApiUrl}/api/ModuleName?moduleId=${data.id}`;
            console.log(apiUrl);
            const response = await axios.put(apiUrl, {
                id: data.id,
                moduleName: data.moduleName,
                moduleDescription: data.moduleDescription,
            }, {
                withCredentials: true,
                credentials: 'include',
            });

            console.log("Response:", response.data);
            return response.data;
        } catch (error) {
            console.error('Error:', error.message);
            if (error.message == "Request failed with status code 401" || error.message == "Access denied. Token not provided" || error.message == "Request failed with status code 403") {
                localStorage.removeItem('loginAccountUserData');
                localStorage.removeItem("loginUser");
                localStorage.clear();
                await User.Logout();
                window.location.href = "/loginpanel";
            }

            if (error.response && error.response.status === 401) {
                alert("Failed");
            } else {
                alert("An error occurred. Please try again.");
            }
        }
    },
};

export default ModuleName;
